import { BusWorker } from "./BusWorker";
import { MESSAGE_SEPERATOR, ANSWER_MESSAGE_SEPERATOR, unwrapMessage, wrapMessage, METADATA_SEPERATOR } from "flavr-common";
import { SubscribeMessage, ConnectMessage, HandshakeMessage, WorkerDiedMessage, RequestBusSubscriptionsReadyMessage, BusSubscriptionsReadyMessage } from "../BusMessages";
const busWorkers = new Map();
function getBusWorker(appUid) {
    let busWorker = busWorkers.get(appUid);
    if (busWorker === undefined)
        busWorkers.set(appUid, (busWorker = new BusWorker()));
    return busWorker;
}
export class EventReceiver {
    constructor(port) {
        this.port = port;
        this.workerId = "";
    }
    receiveEvent(messageEvent) {
        const data = messageEvent.data;
        this.handleMessage(data);
    }
    handleMessage(data) {
        if (typeof data !== "string") {
            const pattern = data.pattern;
            const askId = data.askId;
            const timeStamp = data.timeStamp;
            const targetWorkerId = data.targetWorkerId;
            // ToDo handle system msg
            // if (pattern.startsWith("system")) {
            // }
            if (data.isTransfer) {
                if (targetWorkerId === undefined) {
                    return;
                }
                if (!this.busWorker) {
                    return;
                }
                const keys = Reflect.ownKeys(data.objData);
                const transfer = [];
                for (const key of keys) {
                    const value = data.objData[key];
                    if (value instanceof ArrayBuffer) {
                        transfer.push(value);
                        continue;
                    }
                    if (value.buffer && value.buffer instanceof ArrayBuffer) {
                        transfer.push(value.buffer);
                    }
                }
                this.busWorker.sendDataTransferTo(targetWorkerId, data, transfer);
                return;
            }
            if (data.offscreen) {
                if (targetWorkerId === undefined) {
                    return;
                }
                if (!this.busWorker) {
                    return;
                }
                this.busWorker.sendTransferTo(targetWorkerId, [data.offscreen], data);
                return;
            }
            if (data.sharedArrayBuffer) {
                if (targetWorkerId === undefined) {
                    return;
                }
                if (!this.busWorker) {
                    return;
                }
                this.busWorker.sendMessageTo(targetWorkerId, data);
                return;
            }
            if (targetWorkerId !== undefined) {
                this.busWorker && this.busWorker.sendBufferTo(targetWorkerId, this.workerId, pattern, timeStamp, data, askId, targetWorkerId);
                return;
            }
            this.busWorker && this.busWorker.broadcastBuffer(pattern, timeStamp, data, this.workerId, askId);
            return;
        }
        // filter message by subject/type regexp
        const colon = data.indexOf(MESSAGE_SEPERATOR);
        if (colon === -1) {
            throw new Error("Invalid Message, missing MESSAGE_SEPERATOR. have you used busConnection.send() ?");
        }
        if (data.startsWith("system")) {
            this.handleSystemEvent(data);
        }
        const type = data.substring(0, colon);
        const answerPos = type.indexOf(ANSWER_MESSAGE_SEPERATOR);
        if (answerPos !== -1) {
            // send the message to the worker who made the ask request
            const workerId = type.substring(0, answerPos);
            // dont send it back to the worker who sent it
            if (workerId !== this.workerId) {
                this.busWorker && this.busWorker.sendMessageTo(workerId, data);
            }
        }
        else {
            this.busWorker && this.busWorker.broadcastMessage(type, data, this.workerId);
        }
    }
    handleSystemEvent(data) {
        const parsed = unwrapMessage(data);
        if (Array.isArray(parsed))
            return;
        const colon = data.indexOf(MESSAGE_SEPERATOR);
        if (colon === -1) {
            return;
        }
        const msgInfos = data.substring(0, colon).split(METADATA_SEPERATOR);
        if (msgInfos.length === 0) {
            return;
        }
        const workerId = msgInfos[1];
        this.handleSystemMsg(parsed, workerId);
    }
    handleSystemMsg(msg, workerId) {
        if (SubscribeMessage.is(msg)) {
            this.busWorker && this.busWorker.updateSubscriptions(msg, workerId);
        }
        else if (RequestBusSubscriptionsReadyMessage.is(msg)) {
            this.port.postMessage(wrapMessage(new BusSubscriptionsReadyMessage(workerId), "bus", "bus", Date.now()));
        }
        else if (HandshakeMessage.is(msg)) {
            this.port.postMessage(msg);
        }
        else if (ConnectMessage.is(msg)) {
            this.workerId = workerId;
            this.busWorker = getBusWorker(msg.appUid);
            this.busWorker.onWorkerConnected(workerId, this.port);
        }
        else if (WorkerDiedMessage.is(msg)) {
            this.busWorker && this.busWorker.onWorkerDied(msg);
        }
    }
}
